import {getCustomSEO} from '../seo';
import {stripHTML} from '../../string.helper';

/**
 * Tạo SEO cho trang danh sách tuyển dụng
 */
export function generateShareholderRelationshipListSEO(
    shareholderRelationshipNews,
    categories,
    appconfig,
    totalCount,
    webUrl,
) {
    const shareholderRelationshipListUrl = `${webUrl}/quan-he-co-dong`;

    // console.log(appconfig);
    // console.log(categories);

    // Tạo title
    const seoTitle =
        totalCount && totalCount > 0
            ? `Quan hệ cổ đông ${totalCount} tin cổ đông | CTCP Tập đoàn Bệnh viện TNH`
            : 'Quan hệ cổ đông | CTCP Tập đoàn Bệnh viện TNH';

    // Tạo description từ danh sách vị trí quan hệ cổ đông tin tức
    const mapShareholderToString = (settings = {}) => {
        const get = key => settings[key]?.value || '';

        const title = get('SHAREHOLDER_TITLE');
        const email = get('SHAREHOLDER_EMAIL');
        const phone = get('SHAREHOLDER_PHONE');
        const cfo = get('SHAREHOLDER_CFO');
        const coo = get('SHAREHOLDER_COO');

        return [
            title && `📌 ${title}`,
            cfo && `👤 ${cfo}`,
            coo && `👤 ${coo}`,
            email && `📧 Email: ${email}`,
            phone && `📞 Điện thoại: ${phone}`,
        ]
            .filter(Boolean)
            .join('\n');
    };
    const shareholderContactStr = mapShareholderToString(appconfig);
    let seoDescription = '';
    if (
        shareholderRelationshipNews &&
        Array.isArray(shareholderRelationshipNews) &&
        shareholderRelationshipNews.length > 0
    ) {
        // Lấy tên các vị trí chính (tối đa 4-5)
        const mainPositions = shareholderRelationshipNews
            .slice(0, 5)
            .map(news => {
                const title = news.short_description || news.title || '';
                // Loại bỏ HTML tags và giới hạn độ dài
                return stripHTML(title, 50);
            })
            .filter(Boolean);

        const positionTitles = mainPositions.join(', ');
        const count = totalCount || shareholderRelationshipNews.length;

        seoDescription = `CTCP Tập đoàn Bệnh viện TNH có ${count} tin tức quan hệ cổ đông: ${positionTitles}${
            count > 5 ? ' và nhiều tin tức khác' : ''
        } ${shareholderContactStr}`;
    } else {
        seoDescription = `.${shareholderContactStr}`;
    }

    // Giới hạn description
    if (seoDescription.length > 160) {
        seoDescription = seoDescription.substring(0, 157) + '...';
    }

    // Tạo keywords từ danh sách tuyển dụng
    const keywordsParts = [];
    if (shareholderRelationshipNews && Array.isArray(shareholderRelationshipNews)) {
        // Lấy keywords từ các vị trí chính (tối đa 10)
        shareholderRelationshipNews.slice(0, 10).forEach(job => {
            // Thêm tên vị trí
            if (job.recruitment_name) {
                keywordsParts.push(job.title);
            }

            // Thêm short description nếu có
            if (job.short_description && !keywordsParts.includes(job.short_description)) {
                keywordsParts.push(job.short_description);
            }

            // Thêm từ title
            const title = job.title || '';
            if (title) {
                const cleanTitle = stripHTML(title);
                // Lấy các từ quan trọng từ title
                const words = cleanTitle
                    .split(/\s+/)
                    .filter(
                        word =>
                            word.length > 3 &&
                            word.length < 20 &&
                            !['và', 'của', 'cho', 'với', 'từ', 'tại', 'theo', 'vị', 'trí'].includes(word.toLowerCase()),
                    )
                    .slice(0, 3);
                keywordsParts.push(...words);
            }
        });
    }

    // Thêm keywords mặc định cho tuyển dụng
    keywordsParts.push(
        'Quan hệ cổ đông',
        'Nhà đầu tư',
        'TNH',
        'Bệnh viện TNH',
        'CTCP Tập đoàn Bệnh viện TNH',
        'Thông tin nhà đầu tư',
        'Cổ phiếu TNH',
        'Báo cáo tài chính',
        'Đại hội cổ đông',
        'Công bố thông tin',
    );
    const seoKeywords = [...new Set(keywordsParts)].join(', '); // Loại bỏ duplicate

    // Xử lý image - lấy ảnh từ vị trí đầu tiên hoặc dùng default
    let seoImage = '';
    console.log('[SEO] shareholderRelationshipNews (raw):', shareholderRelationshipNews);

    if (shareholderRelationshipNews && typeof shareholderRelationshipNews === 'object') {
        // Gộp tất cả news từ các category thành 1 mảng
        const allNews = Object.values(shareholderRelationshipNews)
            .filter(arr => Array.isArray(arr) && arr.length > 0)
            .flat();

        console.log('[SEO] allNews:', allNews);

        const firstNews = allNews?.[0] ?? null;

        if (firstNews) {
            seoImage = firstNews.image_url || '';

            console.log('[SEO] Raw seoImage:', seoImage);

            // Trường hợp image là array
            if (Array.isArray(seoImage)) {
                seoImage = seoImage[0] || '';
                console.log('[SEO] seoImage after array check:', seoImage);
            }

            // Chuẩn hóa URL
            if (seoImage && !seoImage.startsWith('http://') && !seoImage.startsWith('https://')) {
                seoImage = seoImage.startsWith('/') ? `${webUrl}${seoImage}` : `${webUrl}/${seoImage}`;

                console.log('[SEO] seoImage after normalize URL:', seoImage);
            }
        } else {
            console.log('[SEO] firstNews: null');
        }
    } else {
        console.warn('[SEO] shareholderRelationshipNews is invalid');
    }

    console.log('[SEO] Final seoImage:', seoImage);

    return getCustomSEO(seoTitle, seoDescription, shareholderRelationshipListUrl, seoKeywords, seoImage);
}

/**
 * Tạo SEO cho trang chi tiết tuyển dụng
 */
export function generateShareholderSEO(
    shareholderNews = [],
    categoriesFinal = [],
    shareholderContactFinal = {},
    slug,
    web_url,
) {
    const seoUrl = `${web_url}/${slug}`;

    /* ======================
     * LẤY TIN MỚI NHẤT
     * ====================== */
    const firstNews = Array.isArray(shareholderNews) && shareholderNews.length > 0 ? shareholderNews[0] : null;

    /* ======================
     * TITLE
     * ====================== */
    let seoTitle = 'Quan hệ cổ đông | TNH Hospital Group';

    if (firstNews?.title) {
        seoTitle = `${firstNews.title} | Quan hệ cổ đông TNH`;
    } else if (categoriesFinal?.[0]?.category_name) {
        seoTitle = `${categoriesFinal[0].category_name} | Quan hệ cổ đông TNH`;
    }

    /* ======================
     * DESCRIPTION
     * ====================== */
    let seoDescription = '';

    // 1️⃣ Ưu tiên mô tả ngắn của tin mới nhất
    if (firstNews?.short_description) {
        seoDescription = stripHTML(firstNews.short_description);
    }

    // 2️⃣ Nếu chưa đủ dài → thêm info liên hệ cổ đông
    if (seoDescription.length < 120 && shareholderContactFinal) {
        const contactParts = [];

        if (shareholderContactFinal.SHAREHOLDER_TITLE?.value) {
            contactParts.push(shareholderContactFinal.SHAREHOLDER_TITLE.value);
        }
        if (shareholderContactFinal.SHAREHOLDER_EMAIL?.value) {
            contactParts.push(`Email: ${shareholderContactFinal.SHAREHOLDER_EMAIL.value}`);
        }
        if (shareholderContactFinal.SHAREHOLDER_PHONE?.value) {
            contactParts.push(`Điện thoại: ${shareholderContactFinal.SHAREHOLDER_PHONE.value}`);
        }

        if (contactParts.length) {
            seoDescription = `${seoDescription} - ${contactParts.join(' - ')}`.trim();
        }
    }

    // Giới hạn 160 ký tự
    if (seoDescription.length > 160) {
        seoDescription = seoDescription.substring(0, 157) + '...';
    }

    // Fallback cuối
    if (!seoDescription) {
        seoDescription =
            'Trang quan hệ cổ đông của TNH Hospital Group. Cập nhật công bố thông tin, báo cáo, nghị quyết và tài liệu cổ đông.';
    }

    /* ======================
     * KEYWORDS
     * ====================== */
    const keywordParts = [];

    if (firstNews?.title) keywordParts.push(firstNews.title);

    categoriesFinal.forEach(c => {
        if (c.category_name) keywordParts.push(c.category_name);
    });

    keywordParts.push(
        'Quan hệ cổ đông',
        'Cổ đông TNH',
        'IR TNH',
        'TNH Hospital Group',
        'Báo cáo cổ đông',
        'Đại hội cổ đông',
        'Công bố thông tin',
    );

    const seoKeywords = [...new Set(keywordParts)].join(', ');

    /* ======================
     * IMAGE
     * ====================== */
    let seoImage = firstNews?.image_url || categoriesFinal?.[0]?.image_url || '';

    /* ======================
     * RETURN
     * ====================== */
    return getCustomSEO(seoTitle, seoDescription, seoUrl, seoKeywords, seoImage);
}
